import React from "react";
import {useSelector} from "react-redux";
import {Rnd} from "react-rnd";
import OOBCEditor from "components/OOBCEditor";
import TextCodeEditor from "components/TextCodeEditor";
import iconClose from "images/ic_close.svg";
// import iconCodeAlign from "images/ic_code_align.svg";
// import iconZoomIn from "images/ic_code_zoom_in.svg";
// import iconZoomOut from "images/ic_code_zoom_out.svg";
import "./index.scss";
import {EDITORMODE} from "utils/constants";

// const CodeDeleteAlertPopup = ({ onClickCodeDelete }) => {
//   return (
//     <div className="code-delete-alert-popup">
//       <p>Do you want to delete all?</p>
//       <div className="code-delete-alert-popup__btns">
//         {/* TODO : delete code all */}
//         <div onClick={() => onClickCodeDelete(false)}>Yes</div>
//         <div onClick={() => onClickCodeDelete(false)}>No</div>
//       </div>
//     </div>
//   )
// }

const View = ({popupSetting, isClickCodeDelete, onClickCodeDelete, onChangePopupSetting, onClickCloseBtn}) => {
  const codeEditor = useSelector(state => state.codeEditor);

  return (
    <Rnd
      default={{
        x: popupSetting.x,
        y: popupSetting.y,
        width: popupSetting.width,
        height: popupSetting.height,
      }}
      minWidth="400"
      minHeight="500"
      cancel=".rnd-drag-cancel"
    >
      <div className="code-editor">
        <>
          {codeEditor.editorMode === EDITORMODE.JAVASCRIPT_3D && <TextCodeEditor />}
          {codeEditor.editorMode === EDITORMODE.BLOCK && <OOBCEditor selectorMode="float" />}
        </>
        <button className="code-editor__close-button" onClick={onClickCloseBtn} onTouchEnd={onClickCloseBtn}>
          <img src={iconClose} alt="close" />
        </button>
        {/* <div className="code_editor__settings">
          <div
            className={`code_editor__code-delete ${isClickCodeDelete ? "code_editor__code-delete--on" : ""}`}
            onClick={() => onClickCodeDelete(true)}
          />
          <img src={iconCodeAlign} alt="" className="code_editor__code-align" />
          <img src={iconZoomIn} alt="" className="code_editor__zoom-in" />
          <img src={iconZoomOut} alt="" className="code_editor__zoom-out" />
          {isClickCodeDelete && <CodeDeleteAlertPopup onClickCodeDelete={onClickCodeDelete}/>}
        </div> */}
      </div>
    </Rnd>
  );
};

export default View;
